import { forwardRef, type Ref, type SVGProps } from "react";
const IconCheckedBoxFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M17 8H8v16h16v-7h4v8a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10z" />
    <path d="M27.628 7.163a2 2 0 1 0-3.255-2.325L15.6 17.119l-3.35-2.68a2 2 0 0 0-2.5 3.123l5 4a2 2 0 0 0 2.878-.4z" />
  </svg>
);
const ForwardRef = forwardRef(IconCheckedBoxFilledSVG);
ForwardRef.displayName = "IconCheckedBoxFilled";
export { ForwardRef as IconCheckedBoxFilled };
